<!-- Menu Left -->
<mat-nav-list class="left-menu" style="margin-top: 80px">

  <!-- Documentation -->
  <mat-list-item>
    <a routerLink="public" routerLinkActive="active" #publicRL="routerLinkActive">
      <h3 i18n="@@itemMenu-Documentation">Documentazione</h3>
    </a>
  </mat-list-item>

  @if (publicRL?.isActive) {
    <mat-list-item>
      <a routerLink="public/home" routerLinkActive="active" class="secondLevel"><h3>Home</h3></a>
    </mat-list-item>
    <mat-list-item>
      <a routerLink="public/payment-methods" routerLinkActive="active" class="secondLevel">
        <h3 i18n="@@itemMenu-PaymentMethod">Metodi di pagamento</h3>
      </a>
    </mat-list-item>
  }

  <!-- Sandbox -->
  @if (merchantService.accessAllowed === true) {
    <div style="margin-top: 0px;">
      <mat-list-item>
        <a routerLink="sandbox" routerLinkActive="active" #sandboxRL="routerLinkActive">
          <h3 i18n="@@itemMenu-AreaTest">Test area</h3>
        </a>
      </mat-list-item>

      @if (sandboxRL?.isActive) {
        <mat-list-item>
          <a routerLink="sandbox/transactions" routerLinkActive="active" class="secondLevel">
            <h3 i18n="@@itemMenu-Transaction">Test transazioni</h3>
          </a>
        </mat-list-item>

        <mat-list-item>
          <a routerLink="sandbox/transactions-summary" routerLinkActive="active" class="secondLevel">
            <h3 i18n="@@transaction-summary">Sommario transazioni</h3>
          </a>
        </mat-list-item>

        <mat-list-item>
          <a routerLink="sandbox/configuration" routerLinkActive="active" class="secondLevel" #configRL="routerLinkActive">
            <h3 i18n="@@itemMenu-Configuration">Configurazione</h3>
          </a>
        </mat-list-item>

        @if (configRL?.isActive) {
          <mat-list-item>
            <a routerLink="sandbox/configuration/solutions" routerLinkActive="active" class="thirdLevel">
              <h4 i18n="@@itemMenu-Solution">Soluzioni</h4>
            </a>
          </mat-list-item>
          <mat-list-item>
            <a routerLink="sandbox/configuration/payment-methods" routerLinkActive="active" class="thirdLevel">
              <h4 i18n="@@itemMenu-PaymentMethod">Metodi di pagamento</h4>
            </a>
          </mat-list-item>
        }

        <mat-list-item>
          <a routerLink="sandbox/downloads" routerLinkActive="active" class="secondLevel" #downloadRL="routerLinkActive">
            <h3 i18n="@@itemMenu-Download">Download</h3>
          </a>
        </mat-list-item>

        @if (downloadRL?.isActive) {
          <mat-list-item>
            <a routerLink="sandbox/downloads/plugin" routerLinkActive="active" class="thirdLevel"><h4>Plugin</h4></a>
          </mat-list-item>
          <mat-list-item>
            <a routerLink="sandbox/downloads/sdk" routerLinkActive="active" class="thirdLevel">
              <h4 i18n="@@itemMenu-SdkInApp">SDK per In-App</h4>
            </a>
          </mat-list-item>
        }
      }
    </div>
  }

  <!-- Production -->
  @if (merchantService.currentMerchant?.role === 'USER') {
    <div style="margin-top: 20px;">
      <mat-list-item>
        <a routerLink="production/configuration" routerLinkActive="active" #prodRL="routerLinkActive">
          <h3 i18n="@@production-configuration">Configura produzione</h3>
        </a>
      </mat-list-item>

      @if (prodRL?.isActive) {
        <mat-list-item>
          <a routerLink="production/configuration/solutions" routerLinkActive="active" class="secondLevel">
            <h3 i18n="@@itemMenu-Solution">Soluzioni</h3>
          </a>
        </mat-list-item>

        @if (merchantService.currentProductionMerchant) {
          <div>
            <mat-list-item>
              <a routerLink="production/configuration/payment-methods" routerLinkActive="active" class="secondLevel">
                <h3 i18n="@@itemMenu-PaymentMethod">Metodi di pagamento</h3>
              </a>
            </mat-list-item>

            <mat-list-item>
              <a routerLink="production/configuration/transactions-summary" routerLinkActive="active" class="secondLevel">
                <h3 i18n="@@transaction-summary">Sommario transazioni</h3>
              </a>
            </mat-list-item>
          </div>
        }
      }
    </div>
  }
</mat-nav-list>
